import React, {useState} from "react"
import Data from "../../../../data"

// components
import Features from "./Features"

// the component
function OnlineEventInfos({activity}) {
  // we do currently not display any specific info ... leaving it in here for possible future use
  return null;

  const [items] = useState([
    {key:"c", text:`Wunschtermin muss mindestens ${Data.Properties.getRedeemTimeframe().onlineevent} Tage im Voraus angegeben werden`},
    //{key:"d", text:"bla bla bla"}
  ])

  // not online event? don't render
  if(!activity.isOnlineEvent) {
    return null
  }

  // render
  return (
    <Features 
      title="Online-Event - Hinweise" 
      items={items}
    />
  )
}

export default OnlineEventInfos